module.exports = __webpack_public_path__ + "static/media/discover.38079c69.svg";